import { useState, useTransition } from 'react';
import './LoginForm.css';
import { useForgotPasswordMutation } from '../api/authApi';

export default function ForgotPasswordForm({ setView }) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [isPending, startTransition] = useTransition();
  const [forgotPasswordApi] = useForgotPasswordMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMsg('');

    if (!email.trim()) {
      setError('Email address is required');
      return;
    }

    startTransition(async () => {
      try {
        const response = await forgotPasswordApi({ email: email.trim() }).unwrap();
        if (response.success) {
          setSuccessMsg(response.message);
        }
      } catch (err) {
        setError(err?.data?.message || err?.message || 'Something went wrong. Please try again.');
      }
    });
  };

  return (
    <div className="container">
      <div className="card">
        <h1 className="title">Forgot Password</h1>
        <p style={{ textAlign: 'center', color: '#4a5568', fontSize: '0.9rem', margin: '0.5rem 0 1.25rem' }}>
          Enter your registered email and we'll send you a reset link.
        </p>

        {error && <p className="error">{error}</p>}

        {successMsg ? (
          <div style={{
            background: '#f0fff4', border: '1px solid #9ae6b4', borderRadius: '8px',
            padding: '0.875rem 1rem', color: '#276749', fontSize: '0.875rem', marginBottom: '1rem'
          }}>
            {successMsg}
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="form">
            <div className="formGroup">
              <label htmlFor="email" className="label">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={(e) => { setEmail(e.target.value); setError(''); }}
                className="input"
                placeholder="abc@example.com"
                disabled={isPending}
              />
            </div>

            <button type="submit" className="button" disabled={isPending}>
              {isPending ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>
        )}

        <div className="footer">
          <button
            type="button"
            onClick={() => setView('login')}
            className="link"
            style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '0.875rem' }}
          >
            ← Back to Login
          </button>
        </div>
      </div>
    </div>
  );
}
